export enum FunctionType {
  custom = 'CUSTOM',
  reuseable = 'REUSEABLE'
}
